import { styled } from '@uhg-abyss/web/tools/styled';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Text } from '@uhg-abyss/web/ui/Text';

import { desktopOnly, notMobile } from '../../ConstantsStyles';

export const AttributeLabel = styled(Text, {
  '&.abyss-text-root': {
    paddingBottom: '$sm',
  },
});

export const AttributeValue = styled(Text, {
  '&.abyss-text-root': {
    paddingLeft: '$xs',
  },
});

export const ComparisonGridContainer = styled('div', {
  display: 'grid',
  gridTemplateColumns: '1fr',
  height: '508px',
  overflowY: 'auto',
  [`@media ${notMobile}`]: {
    height: '542px',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'repeat(7, auto)',
  },
  [`@media ${desktopOnly}`]: {
    height: '542px',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  },
});

export const ProviderCard = styled(Card, {
  '&.abyss-card-root': {
    fontFamily: '$primary',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    // below tablet: top/left/right $md, bottom 32px
    padding: `$md $md 32px $md`,
    border: 'none',
    marginTop: '0px',
    boxShadow: 'none',
    borderRadius: '0px',
    [`@media ${notMobile}`]: {
      // tablet up to desktop: $md on all sides
      display: 'grid',
      gridRow: 'span 7',
      gridTemplateRows: 'subgrid',
      padding: '$md',
    },
    [`@media ${desktopOnly}`]: {
      // desktop and up: $md top/bottom, $sm left/right
      padding: `$md $sm`,
    },
  },
  variants: {
    variant: {
      white: {
        '&.abyss-card-root': {
          backgroundColor: 'white',
        },
      },
      gray: {
        '&.abyss-card-root': {
          backgroundColor: '$core.color.neutral.10',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'white',
  },
});

export const providerCardTitle = {
  'abyss-text-root': {
    color: '$primary1',
    marginBottom: '$md',
    [`@media ${desktopOnly}`]: {
      display: '-webkit-box',
      marginBottom: '$xs',
    },
  },
};

export const ctaButtonStyles = {
  'abyss-button-root': {
    width: '100%',
    borderRadius: '24px',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '24px',
    marginTop: '32px',
    [`@media ${notMobile}`]: {
      alignSelf: 'end',
    },
    [`@media ${desktopOnly}`]: {
      fontSize: '14px',
      lineHeight: '18px',
    },
  },
};

export const descriptionTextCss = {
  'abyss-text-root': {
    paddingBottom: '$md',
  },
};

export const ProviderAttributeContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: '$md',
});

export const costIndicatorCss = {
  paddingLeft: '$xs',
  paddingRight: '$xs',
};
